var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('GmapMap',{ref:"mapRef",staticStyle:{"width":"100%","height":"300px"},attrs:{"center":_vm.formOkBoy.coordenadasMap,"zoom":17,"map-type-id":"terrain","options":{
      streetViewControl: false,
      fullscreenControl: false,
      mapTypeControl: false,
    }}},[_c('GmapMarker',{attrs:{"position":_vm.formOkBoy.coordenadasMap,"clickable":false,"draggable":false}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }